import { isFolderDocument, type SingleDocument } from '@/store/documents/documents.dto';

export const EMPTY_VALUE = '-';

/**
 * Breadcrumb label for a path segment. The vessel-scoped gallery route
 * (`<vesselId>.gallery`) has no folder name in navigation state, so fall back
 * to a friendly label instead of showing the raw id.
 */
export const getSegmentLabel = (id: string, name?: string) =>
  name ?? (id.endsWith('.gallery') ? 'Gallery' : id);

export const formatFileCount = (count: number) => `${count} ${count === 1 ? 'file' : 'files'}`;

export const formatSize = (bytes: number) => {
  if (!bytes) return '0 KB';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** i;
  return `${i === 0 ? value : value.toFixed(value < 10 ? 1 : 0)} ${units[i]}`;
};

export const formatDocumentDate = (date: string) =>
  new Date(date).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export const getFileType = (document: SingleDocument) => {
  if (isFolderDocument(document)) return EMPTY_VALUE;
  const extension = document.name.includes('.') ? document.name.split('.').pop() : '';
  if (extension) return extension.toUpperCase();
  const subtype = document.contentType?.split('/').pop();
  return subtype ? subtype.toUpperCase() : EMPTY_VALUE;
};
